import { computed, type ComputedRef } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'

interface UseButtonFlipdown {
  disabled: ComputedRef<boolean>
  doFlipDown: Function
}

//------------------------------------------------
export function useButtonFlipdown(): UseButtonFlipdown {
  const samudkoyStore = useSamudkoyStore()

  const disabled = computed(() => !samudkoyStore.hasPagePrev)

  function doFlipDown() {
    samudkoyStore.translateOff()
    samudkoyStore.flipDown()
  }

  return {
    disabled,
    doFlipDown,
  }
}

//------------------------------------------------
export function useButtonFlipdownMock(): UseButtonFlipdown {
  const disabled = computed(() => false)

  function doFlipDown() {
    console.debug('doFlipDown()')
  }

  return {
    disabled,
    doFlipDown,
  }
}
